import {AfterViewInit, Component, OnInit} from '@angular/core';
import { Localiser } from '../../services/localiser';
import { UserService } from '../../services/user.service';
import { EmpresaService } from '../../services/empresa.service';
import { MatDialog } from '@angular/material/dialog';

import { empresa } from '../../models/empresa';
import { user } from '../../models/user';
import { ChangeProjectComponent } from './change-project/change-project.component';
import {NewEmpresaComponent} from './new-empresa/new-empresa.component';
import {NewProyectoComponent} from './new-proyecto/new-proyecto.component';
import {NewUserComponent} from './new-user/new-user.component';
import {DeleteUserComponent} from "./delete-user/delete-user.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {DatePipe} from '@angular/common';
import {DeleteProjectComponent} from './delete-project/delete-project.component';
import {DeleteCompanyComponent} from './delete-company/delete-company.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements AfterViewInit {

  empresaSeleccionada: empresa = null;
  empresaSeleccionadaS: string = "";
  empresas: empresa[];
  usuarios: user[] = [];
  idUsuario: string;

  constructor(public localiser: Localiser, public userService: UserService, public empresaService: EmpresaService,
              public matDialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.idUsuario = this.userService.getId();
    if (this.userService.getPermiso() != 'Administrador') {
      this.empresaService.getById(this.userService.getEmpresa()).subscribe(result => {
        this.empresaSeleccionada = <empresa> result;
      });
      this.userService.getByIdEmpresa(this.userService.getEmpresa()).subscribe(result => {
        this.usuarios = <Array<user>> result;
      });
    } else if (this.userService.getPermiso() == 'Administrador') {
      this.empresaService.getAll().subscribe(result => {
        this.empresas = <Array<empresa>> result;
        this.changeEmpresa(this.empresas[0].nombre)
      });
    }
  }

  changePermiso(idUsuario, idPermiso) {
    this.userService.changePermiso(idUsuario, idPermiso);
  }

  changeEmpresa(nombre) {
    this.empresaService.getById(this.getIdEmpresaByNombre(nombre)).subscribe(result => {
      this.empresaSeleccionada = <empresa> result;
      this.empresaSeleccionadaS = this.empresaSeleccionada.nombre;
    });
    this.userService.getByIdEmpresa(this.getIdEmpresaByNombre(nombre)).subscribe(result => {
      this.usuarios = <Array<user>> result;
    });
  }

  getIdEmpresaByNombre(nombre) {
    if (this.empresaSeleccionada != null && this.empresaSeleccionada.nombre == nombre) {
      return this.empresaSeleccionada.idEmpresa
    } else {
      for (let empresa of this.empresas) {
        if (empresa.nombre == nombre) {
          return empresa.idEmpresa;
        }
      }
    }
  }

  changeProjects(usuario) {
    let dialog = this.matDialog.open(ChangeProjectComponent, {
      width: '60%',
      height: '60%',
      data: {usuario: usuario, empresa: this.empresaSeleccionada}
    });

    dialog.afterClosed().subscribe(() => { this.changeEmpresa(this.empresaSeleccionada.nombre) } );
  }

  newEmpresa() {
    let dialog = this.matDialog.open(NewEmpresaComponent, {
      width: '60%',
      height: '70%'
    });

    dialog.afterClosed().subscribe(() => {
      this.empresaService.getAll().subscribe(result => {
      this.empresas = <Array<empresa>> result;
      });
    });
  }

  newProyecto() {
    let dialog = this.matDialog.open(NewProyectoComponent, {
      width: '60%',
      height: '70%',
      data: {empresa: this.empresaSeleccionada}
    });

    dialog.afterClosed().subscribe(() => { this.changeEmpresa(this.empresaSeleccionada.nombre) } );
  }

  deleteProject() {
    let dialog = this.matDialog.open(DeleteProjectComponent, {
      width: '50%',
      height: '50%',
      data: {}
    });

    //dialog.afterClosed().subscribe(() => { this.changeEmpresa(this.empresaSeleccionada.nombre) } );
  }

  deleteCompany() {
    let dialog = this.matDialog.open(DeleteCompanyComponent, {
      width: '50%',
      height: '50%',
      data: {}
    });

    //dialog.afterClosed().subscribe(() => { this.changeEmpresa(this.empresaSeleccionada.nombre) } );
  }

  newUser() {
    let dialog = this.matDialog.open(NewUserComponent, {
      width: '60%',
      height: '85%',
      data: {empresa: this.empresaSeleccionada}
    });

    dialog.afterClosed().subscribe(() => { this.changeEmpresa(this.empresaSeleccionada.nombre) } );
  }

  deleteUser(user) {
    let dialog = this.matDialog.open(DeleteUserComponent, {
      width: '50%',
      height: '50%',
      data: {usuario: user, empresa: this.empresaSeleccionada}
    });

    dialog.afterClosed().subscribe(() => { this.changeEmpresa(this.empresaSeleccionada.nombre) } );
  }

  resetPassword(user) {
    let dialog = this.matDialog.open(ResetPasswordComponent, {
      width: '50%',
      height: '35%',
      data: {usuario: user}
    });

    dialog.afterClosed().subscribe(() => { this.changeEmpresa(this.empresaSeleccionada.nombre) } );
  }

  changeLicenseDate(usuario: any) {

    // Call your backend API to update the license expiry date
    const pipe = new DatePipe('en-US');
    const formattedDate = pipe.transform(usuario.licenseExpiryDate, 'yyyy-MM-dd');
    this.userService.updateLicenseExpiry(usuario.idUsuario, formattedDate);

  }

}
